<div class="mb-3 message-container blue-fill p-3">
  @if (!isCheckoutWizard) {
    <div class="mb-3">
      <mwp-text-translate text="You have benefits that currently do not have any designated beneficiaries. Please assign beneficiaries for the coverage(s) below." jsonKey="beneficiariesWizardNote" />
    </div>
  }
  <div [innerHTML]="instructionHTML | pipeSafeHTML"></div>
</div>
@if (isCheckoutWizard) {
  <div class="mb-3">
    <mwp-table header='Benefits' [tableColumns]="benefitSummaryColumns" [dataSource]="benefitSummaryTableData" />
  </div>
}
<div>
  <mwp-beneficiaries-form [benefitBeneficiaryCard]="benefitBeneficiaryCard" [hideWizardCancelButton]="isCheckoutWizard" [isWizardComponent]="true" [isEmitPaylod]="true" (emitCancel)="cancel()" (emitSavePayload)="submitComplete($event)" [isEnrollment]="true" saveButtonText="save" />
</div>